import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import * as React from 'react';
import { useMemo, useRef } from 'react';
import { isDark } from '../common/utils';
import styles from './card.module.scss';
const Card = ({ alignFooter = 'left', alignHeader = 'left', border = false, children, footer, header, height = 200, shadow = true, }) => {
    const ref = useRef(null);
    const isDarkMode = useMemo(() => isDark(), []);
    const style = useMemo(() => {
        return {
            '--height': `${height}px`,
            gridTemplateRows: `${header ? '50px' : ''} 1fr ${footer ? '50px' : ''}`.trim(),
        };
    }, [height]);
    const cardWrapperClass = useMemo(() => {
        return classNames(styles.wrapper, {
            [styles.border_less]: !border,
            [styles.shadow]: shadow,
            [styles.dark]: isDarkMode,
        });
    }, [border]);
    const cardHeaderClass = useMemo(() => {
        return classNames(styles.header, {
            [styles[`align_${alignHeader}`]]: true,
        });
    }, []);
    const cardFooterClass = useMemo(() => {
        return classNames(styles.footer, {
            [styles[`align_${alignFooter}`]]: true,
        });
    }, []);
    return (_jsxs("div", { className: cardWrapperClass, style: style, ref: ref, children: [header && _jsx("header", { className: cardHeaderClass, children: header }), _jsx("section", { className: styles.body, children: children }), footer && _jsx("footer", { className: cardFooterClass, children: footer })] }));
};
Card.displayName = 'Card';
export { Card };
